module.exports = __webpack_public_path__ + "img/personalPac-log.9fa4188c.svg";